import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../assets/css/projects.css";
import bookshelImage from "../assets/img/bookshelf.png";
import callofDutyImage from "../assets/img/callofd.png";
import trainersImage from "../assets/img/trainers.png";
import dailyImage from "../assets/img/daily.png";

function ProjectPage() {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);

  const projects = [
    {
      id: 0,
      title: "Bookshelf",
      descKey: "projects.bookshelf-description",
      image: bookshelImage,
      link: "https://daniltop3245.github.io/BookShelfOnReact/",
      tags: ["React.js", "JavaScript", "HTML5", "CSS3", "API"]
    },
    {
      id: 1,
      title: "Call of Duty",
      descKey: "projects.call-of-duty-description",
      image: callofDutyImage,
      link: "https://daniltop3245.github.io/CallOfDuty/",
      tags: ["JavaScript", "HTML5", "CSS3", "Firebase"]
    },
    {
      id: 2,
      title: "Trainers site",
      descKey: "projects.trainers-description",
      image: trainersImage,
      link: "https://daniltop3245.github.io/trainers/",
      tags: ["HTML5", "CSS3", "Flexbox", "UI/UX"]
    },
    {
      id: 3,
      title: "DAILY",
      descKey: "projects.daily-description",
      image: dailyImage,
      link: "https://daily-a2hj.onrender.com/",
      tags: ["React.js", "Node.js", "MongoDB", "Cloudflare", "Tailwind CSS", "JWT", "Axios", "Vite", "Express.js", "bcrypt", "React Router DOM", "AI Integrations"]  
    }
  ];

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + projects.length) % projects.length);
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % projects.length);
  };

  const handleGoTo = (idx) => {
    setActiveIndex(idx);
  };

  return (
    <section id="projects" className="section reveal projects-page">
      <div className="projects-header">
        <h2 className="gradient-text">{t("projects.heading")}</h2>
        <p>{t("projects.text")}</p>
      </div>

      <div className="projects-flat-slider-container">
        <div className="projects-slider-track">
          {projects.map((project, idx) => {
            // Calculate relative offset of this slide from activeIndex
            let offset = idx - activeIndex;
            // Handle loop wrap for prev/next animations
            if (offset < -1 && activeIndex === projects.length - 1 && idx === 0) offset = 1;
            if (offset > 1 && activeIndex === 0 && idx === projects.length - 1) offset = -1;
            // Far slides
            if (offset < -1) offset = -2;
            if (offset > 1) offset = 2;

            let positionClass = "hidden";
            if (offset === 0) positionClass = "active";
            else if (offset === 1 || offset > 1) positionClass = "next";
            else if (offset === -1 || offset < -1) positionClass = "prev";

            return (
              <div
                key={project.id}
                className={`project-split-card ${positionClass}`}
                onClick={positionClass !== "active" ? () => handleGoTo(idx) : undefined}
              >
                {/* Visual Side (Mockup Browser & Image) */}
                <div className="project-visual-side">
                  {/* Simulated browser top bar */}
                  <div className="card-mockup-header">
                    <div className="mockup-dots">
                      <span className="mockup-dot dot-red"></span>
                      <span className="mockup-dot dot-yellow"></span>
                      <span className="mockup-dot dot-green"></span>
                    </div>
                    <a
                      href={project.link}
                      className="mockup-address"
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "none", cursor: "pointer" }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {project.link}
                    </a>
                  </div>

                  {/* Project Image Frame */}
                  <div className="project-image-box">
                    <img src={project.image} alt={project.title} className="project-img" />
                    <div className="project-image-overlay">
                      <a
                        href={project.link}
                        className="btn btn-primary"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {t("projects.visit-site")}
                      </a>
                    </div>
                  </div>
                </div>

                {/* Info Side (Details & Controls) */}
                <div className="project-info-side">
                  <div>
                    <div className="project-title-row">
                      <h3 className="project-card-title-text">{project.title}</h3>
                    </div>

                    <div className="project-description-container">
                      <p className="project-card-description-text">
                        {t(project.descKey)}
                      </p>
                    </div>

                    {/* Technology Tags */}
                    <div className="project-card-tags">
                      {project.tags.map((tag, tIdx) => (
                        <span key={tIdx} className="project-card-tag">{tag}</span>
                      ))}
                    </div>
                  </div>

                  {/* Actions row at the bottom of info side */}
                  <div className="project-actions-row">
                    <a
                      href={project.link}
                      className="btn btn-primary"
                      target="_blank"
                      rel="noreferrer"
                      style={{ padding: "10px 24px", fontSize: "13px" }}
                    >
                      {t("projects.visit-site")}
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Carousel Controls */}
        <div className="slider-nav">
          <button
            aria-label="previous"
            className="btn-ctrl"
            onClick={handlePrev}
          >
            ←
          </button>
          
          <div className="slider-indicators">
            {projects.map((proj, idx) => (
              <span
                key={proj.id}
                className={`slider-dot ${activeIndex === idx ? "active" : ""}`}
                onClick={() => handleGoTo(idx)}
              />
            ))}
          </div>

          <button
            aria-label="next"
            className="btn-ctrl"
            onClick={handleNext}
          >
            →
          </button>
        </div>
      </div>
    </section>
  );
}

export default ProjectPage;
